import styled from "styled-components";

export const Container = styled.section`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${({ gap = "30px" }) => gap};
    width: 600px;
    @media (max-width: 730px) {
        width: unset;
    }
`;
export const Content = styled.article`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    & *:not(img) {
        text-align: center;
    }
    & h3 {
        color: var(--purple-6);
        font-weight: 900;
        font-size: 20px;
        margin: 12px 0;
        margin-top: 25px;
        &.secondary {
            color: var(--dark-4);
        }
    }
    & p, h4, ul {
        font-size: 14px;
        color: var(--light-gray-5);
    }
    & ul {
        line-height: 20px;
    }
    & h4 {
        font-weight: 400;
        margin: 0;
        margin-bottom: 15px;
    }
    & p {
        margin: 0;
        margin-top: 5px;
        text-overflow: ellipsis;
        overflow: hidden;
        width: ${({ widthParagraph = "70%" }) => widthParagraph};
    }
`;
export const Footer = styled.footer`
    display: flex;
    gap: 15px;
`;